<template>
  <footer>
    <a href="https://www.ctbcbank.com/twrbo/zh_tw/index/ctbc_aboutCTBC/ctbc_legal/ctbc_finances.html?targetTab=ctbc_finances_tab2" alt="中國信託官網" title="中國信託官網" target="_blank"></a>
  </footer>
</template>

<script>
export default {

}
</script>

<style>
</style>
